<template>
  <div id="app">
    <div class="navbar-background"></div>
    <div class="container-vue">
      <header class="header">
        <navbar></navbar>
      </header>

      <div class="content">
        <transition name="fade" mode="out-in">

        <router-view></router-view>
        </transition>
      </div>

      <footer class="footer"></footer>
    </div>
  </div>
</template>

<script>

import Navbar from "./components/Navbar";
import authAPI from "./services/authAPI";

export default {
  name: 'App',
  components: {Navbar},
  computed:{
    token() {
      return authAPI.storeToken.token
    }
  },
  mounted() {
    this.$store.dispatch('user/initTokenSync')
    
    if(this.$userManager.getToken())
      authAPI.storeToken.token = this.$userManager.getToken()
  },
  beforeDestroy() {
    this.$store.dispatch('user/stopTokenSync')
  },
  watch: {
    'token': function (newValue) {
      if (newValue)
        this.$userManager.setToken(newValue)
      else {
        this.$userManager.logout()
        // this.$router.push("login")
      }
    },
  },
}
</script>

<style>
* {
  --header-height: 56px;
  --header-color: #f8f9fa;
  --overlay-decalage: 60px;
  --color1: #43425D;
  --color2: #677F8E;
  --color3: #A4A128;
}

html, body {
  height: 100%;
}

a {
  color: #43425d !important;
}

.badge-info {
  color: #fff;
  background-color: var(--color3) !important;
}

/* FIN Overwrite bootstrap */

#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
}

.navbar-background {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  background-color: var(--header-color);
  height: var(--header-height);
}

.b-overlay-app {
  height: calc(100vh - var(--header-height) - 20px); /* - var(--overlay-decalage)*/
}

/*
    div.b-overlay.position-absolute div.position-absolute.bg-light.rounded-sm {
    transform: translateY(var(--overlay-decalage));
    }
*/
.header {
  z-index: 99;
}

.container-vue {
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.header {
  height: var(--header-height);
}

.header nav {
  border-bottom: solid 1px rgba(44, 62, 80, 0.3);
  background-color: rgba(12, 118, 161, 0.02);
  box-shadow: 0 4px 2px -4px rgba(54, 54, 54, 0.7);
}

.content {
  flex: auto;
  max-height: calc(100vh - var(--header-height));
  padding-top: 10px;
}



</style>
